import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ACCOUNT_SETTINGS_NAV_ITEMS } from './account-settings-nav';

@Component({
  selector: 'app-account-settings-nav',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './account-settings-nav.component.html',
  styleUrls: ['./account-settings-nav.component.scss']
})
export class AccountSettingsNavComponent {
  @Input() fullWidth = false;

  readonly items = ACCOUNT_SETTINGS_NAV_ITEMS;
}
